export enum ValidatorIdentifier {
    UniqueLocationName = 'uniqueLocationName',
    CustomPropUniqueKey = 'customPropUniqueKey',
    FastRateValidator = 'fastRateValidator',
    NormalRateValidator = 'normalRateValidator',
    UniqueSerialNumber = 'uniqueSerialNumber',
    UniqueCustomPropKey = 'uniqueCustomPropKey',
    ManholeDepthToPipeHeightValidator = 'manholeDepthToPipeHeightValidator',
    DeliveryRateValidator = 'deliveryRateValidator',
}


export enum ButtonDisableIdentifier {
    invalid = 'invalid',
    pristine = 'pristine',
    invalidOrPristine = 'invalidOrPristine',
    activateDisabled = 'activateDisabled',
    usgsDisabled = 'usgsDisabled',
    invalidOrUnsaved = 'invalidOrUnsaved'
}